import { render, staticRenderFns } from "./modal-view-product-details.vue?vue&type=template&id=ffb3fed8&scoped=true&lang=pug"
import script from "./modal-view-product-details.js?vue&type=script&lang=js&external"
export * from "./modal-view-product-details.js?vue&type=script&lang=js&external"
import style0 from "./modal-view-product-details.vue?vue&type=style&index=0&id=ffb3fed8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb3fed8",
  null
  
)

export default component.exports